import { AtomEffect, RecoilState } from 'recoil';
import cloneDeep from 'lodash/cloneDeep';
import { setRecoil } from 'recoil-nexus';
import * as Sentry from '@sentry/browser';

import storage from './storage1';
import { isInDebankApp } from './common';

export const localStorageEffect =
  (key: string): AtomEffect<any> =>
  ({ node, onSet, trigger }) => {
    onSet((next: any) => {
      // next is a frozen entity inherited from recoil
      // it will cause storage(proxy) error if assign "next" to "storage" directly

      // onSet 只是个回调勾子，next 已经设置为 atom 的 value 了
      if ((node as any).__storageTrigger) {
        (node as any).__storageTrigger--;
      } else {
        if (isInDebankApp()) {
          return;
        }
        storage[key] = cloneDeep(next);
      }
    });
  };

const syncAtoms: Record<string, RecoilState<any>> = {};

export const registerSyncAtom = (storageKey: string, atom: RecoilState<any>) => {
  syncAtoms[storageKey] = atom;
};

// recoil 的 effect 有自己的想法，还不如手写
window.addEventListener('storage', ({ key: storageKey, newValue, storageArea }: StorageEvent) => {
  // ignore clear() calls
  if (storageArea === localStorage && storageKey !== null) {
    if (syncAtoms[storageKey]) {
      if ((syncAtoms[storageKey] as any).__storageTrigger) {
        (syncAtoms[storageKey] as any).__storageTrigger++;
      } else {
        (syncAtoms[storageKey] as any).__storageTrigger = 1;
      }
      try {
        if (newValue) {
          setRecoil(syncAtoms[storageKey], JSON.parse(newValue));
        } else {
          setRecoil(syncAtoms[storageKey], newValue);
        }
      } catch (error) {
        (syncAtoms[storageKey] as any).__storageTrigger--;
        Sentry.captureException(error);
      }
    }
  }
});
